import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import moviesModule from 'app/store/movies';

const { requestEventSessions, setDaysSessions } = moviesModule.actions;

export default function (eventId, movieId) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!eventId || !movieId) return undefined;

    dispatch(requestEventSessions({ eventId, movieId }));

    return () => dispatch(setDaysSessions(null));
  }, [eventId, movieId, dispatch]);
}
